import React, { useEffect, useState} from 'react';
import { Modal, Form, Input, message, Select, Col, Row } from 'antd';
import { observer } from 'mobx-react';
import { http, addVisitLog, history } from 'libs';
import store from './store';
import gStore from 'store';
import styles from './index.module.less';
import { DebounceSelect } from 'components';

export default observer(function IForm() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [orgId, setOrgId] = useState(JSON.parse(localStorage.getItem('userInfo')).accountCode);
  const [orgName, setOrgName] = useState(JSON.parse(localStorage.getItem('userInfo')).accountName);
  const [applyUserId, setApplyUserId] = useState([]);
  const [applyUserObj, setApplyUserObj] = useState({});
  const [noticeEmailList, setNoticeEmailList] = useState([]);
  const [manageUserId, setManageUserId] = useState();
  const [manageUserObj, setManageUserObj] = useState({});
  const [projectUserList, setProjectUserList] = useState();
  const [sourceType, setSourceType] = useState();

  const { Option } = Select;
  const { TextArea } = Input;
  useEffect(()=>{
    let userList = store.record.projectUserList||[];
    if (store.record&&userList&&userList.length) {
      userList = userList.map((item)=>{
        item.value = item.userCode;
        item.label = item.userName;
        return item;
      })
      setProjectUserList(userList);
    }
    if (store.record?.noticeEmailList?.length) {
      setNoticeEmailList(store.record.noticeEmailList);
    }
    if (store.record.orgCode) {
      setOrgId(store.record.orgCode);
    }
    if (store.record.orgName) {
      setOrgName(store.record.orgName);
    }
    if (store.record.sourceType) {
      setSourceType(store.record.sourceType);
    }
    if (store.record.applyUserCodeList) {
      setApplyUserId(store.record.applyUserCodeList);
    }
  },[store.record])

  useEffect(()=>{
    if (orgId) {
      store.fetchAccountUser({accountCode:orgId});
    }
  },[orgId]);

  const handleChangeNoticeEmails = (value)=>{
    setNoticeEmailList(value);
  }

  function handleSubmit() {
    let formData = form.getFieldsValue();
    if (!orgId&&!store.record.orgCode) {
      return message.error('请选择客户');
    }
    if (!applyUserId?.length) {
      return message.error('请选择申请人');
    }
    if (!formData.projectNo) {
      return message.error('请输入项目号');
    }
    if (!sourceType&&!store.record.sourceType) {
      return message.error('请选择项目渠道');
    }
    if (store.record.status!==0&&store.record.status!==1) {
      return message.error('请选择使用状态');
    }
    formData = {
      ...store.record,
      ...formData,
      orgCode:orgId || store.record.orgCode,
      orgName:orgName || store.record.orgName,
      applyUserCodeList:applyUserId,
      // applyUserName:applyUserObj.name||store.record.applyUserName,
      manageUserName:manageUserObj.name||store.record.manageUserName,
      manageUserCode:manageUserId||store.record.manageUserCode,
      noticeEmailList:noticeEmailList||store.record.noticeEmailList,
      noticeEmails: JSON.stringify(noticeEmailList),
      sourceType:sourceType||store.record.sourceType,
      projectUserList: projectUserList&&projectUserList.map((item)=>({userCode:item.value}))
    }
    setLoading(true);
    if (!store.record.id) {
      addVisitLog({
        pageName: '新建项目',
        fromPageUrl: window.referrerUrl,
        pageUrl:`${window.location.origin}${history.location.pathname}`,
        eventCode: "InsertProject",
        eventName: "新建项目",
        content: JSON.stringify(formData),
      })
    }
    http.post('/javaApi/front/project/editInfo', formData)
        .then(() => {
          message.success('操作成功'); 
          store.formVisible = false;
          store.page = 1;
          store.pageTotal = 0;
          store.fetchRecords();
        }, () => setLoading(false))
  }

  return (
    <Modal
      visible
      maskClosable={false}
      closable={true}
      title={store.record.id ? '编辑项目' : '新建项目'}
      onCancel={()=>store.formVisible = false}
      confirmLoading={loading}
      className={styles.modalContainer}
      onOk={handleSubmit}
      width={1400}>
      <Form form={form} labelCol={{ span: 5 }} wrapperCol={{ span: 18 }} size={'middle'} labelAlign={'right'} initialValues={store.record}>
      <Row >
          <Col span={8}>
            <Form.Item required  label="所属客户">
              <DebounceSelect
                showSearch
                labelInValue
                disabled
                value={store.record.orgName||orgName||orgId}
                placeholder="请录入并选择客户"
                fetchOptions={store.fetchAccount}
                onChange={(newValue) => {
                  setOrgId(newValue.value);
                  setOrgName(newValue.label);
                }}
                style={{
                  width: '100%',
                }}
              />
                {/* <Select
                  showSearch
                  placeholder="请选择客户"
                  value={store.record.orgName||orgId}
                  onChange={(newValue,option) => {
                    setOrgId(newValue);
                    setOrgName(option.children);
                  }}
                  filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                  {gStore.organizations.map(item => (
                    <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
                  ))}
                </Select> */}
            </Form.Item>
            <Form.Item required label="申请人">
              <Select
                  showSearch
                  mode="multiple"
                  style={{
                    width: '100%',
                  }}
                  filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  value={applyUserId}
                  onChange={(newValue,option) => {
                    setApplyUserId(newValue);
                    // setApplyUserObj(option.item)
                  }}
                  placeholder="请选择申请人">
                  {store.userOptions.map(item => (
                    <Option key={item.id} value={item.code} item={item}>{item.name}</Option>
                  ))}
                  </Select>
            </Form.Item>
            <Form.Item name="manageUserName" label="负责人">
              <Select
                  showSearch
                  allowClear
                  style={{
                    width: '100%',
                  }}
                  filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  value={store.record.manageUserName||manageUserId}
                  onChange={(newValue,option) => {
                    setManageUserId(newValue);
                    setManageUserObj(option.item);
                  }}
                  placeholder="请选择负责人">
                  {store.userOptions.map(item => (
                    <Option key={item.id} value={item.code} item={item}>{item.name}</Option>
                  ))}
                  </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name='projectNo' required label="项目号" >
                <Input autoComplete="off" value={store.record.projectNo}></Input>
            </Form.Item>
            {/* <Form.Item required label="申请人手机号码" >
                <Input autoComplete="off" disabled value={applyUserObj.phone||store.record.applyPhone}></Input>
            </Form.Item> */}
            <Form.Item label="项目组成员">
              <Select
                  showSearch
                  mode="multiple"
                  labelInValue
                  style={{
                    width: '100%',
                  }}
                  filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  value={projectUserList}
                  onChange={(newValue) => {
                    setProjectUserList(newValue);
                  }}
                  placeholder="请选择项目组成员">
                  {store.userOptions.map(item => (
                    <Option key={item.id} value={item.code}>{item.name}</Option>
                  ))}
                  </Select>
            </Form.Item>
            <Form.Item label="服务信息接收邮箱" >
                <Select
                  mode="tags"
                  style={{ width: '100%' }}
                  placeholder="多个邮箱之间请用英文逗号隔开"
                  value={noticeEmailList||store.record.noticeEmailList}
                  dropdownStyle={{display:'none'}}
                  onChange={handleChangeNoticeEmails}
                  tokenSeparators={[',']}
                  // options={options}
                />
              {/* <Input autoComplete="off" value={noticeEmailList||store.record.noticeEmailList} onChange={(e)=>handleChangeNoticeEmails(e.target.value)}></Input> */}
            </Form.Item>
          </Col>
          <Col span={8}>
          <Form.Item name='status' required label="使用状态">
                <Select 
                  // style={{ maxWidth: '100px'}}
                  onChange={(val)=>{
                    store.record.status = val;
                  }}
                  value={store.record.status}>
                    <Option key={1} value={1}>启用</Option>
                    <Option key={0} value={0}>禁用</Option>
                </Select>
            </Form.Item>
            {/* <Form.Item required label="申请人邮箱" >
              <Input autoComplete="off" disabled value={applyUserObj.email||store.record.applyEmail}></Input>
            </Form.Item> */}
            <Form.Item required label="项目渠道" >
                <Select
                    style={{
                      width: '100%',
                    }}
                    filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    value={sourceType}
                    onChange={(newValue) => {
                      setSourceType(newValue);
                    }}
                    placeholder="请选择项目渠道">
                    {store.sourceTypeList?.map(item => (
                      <Option key={item?.code} value={item?.code}>{item?.name}</Option>
                    ))}
                </Select>
            </Form.Item>
            <Form.Item name='remark' label="项目号来源" >
              <div>{store.record?.source===2?"泉心":"客户"}</div>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={8}>
            <Form.Item name='remark' label="备注" >
              <TextArea value={store.record.remark} maxLength={200}></TextArea>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
})